import {Action} from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { NotificationGroupModel } from '@smarttask-common/src/lib/models/Notification/NotificationGroupModel';

export enum NotificationActionTypes {
  ADD_NOTIFICATION = '[Notification] Create Notification',
  UPSERT_NOTIFICATION = '[Notification] Upsert Notification',
  ADD_NOTIFICATIONS = '[Notification] Add Notifications',
  UPSERT_NOTIFICATIONS = '[Notification] Upsert Notifications',
  UPDATE_NOTIFICATION = '[Notification] Update Notification',
  UPDATE_NOTIFICATIONS = '[Notification] Update Notifications',
  DELETE_NOTIFICATION = '[Notification] Delete Notification',
  DELETE_NOTIFICATIONS = '[Notification] Delete Notifications',
  DELETE_ALL_NOTIFICATIONS = '[Notification] Delete All Notifications',
  DELETE_ALL = '[Notification] Delete All',

  UPDATE_SELECTED_ID = '[Notification] Update SelectedId'
}

export class UpdateSelectedNotificationId implements Action{
  readonly type = NotificationActionTypes.UPDATE_SELECTED_ID;
  constructor(public selected_notification_id: string){}
}

export class AddOne implements Action{
  readonly type = NotificationActionTypes.ADD_NOTIFICATION;
  constructor(public notification: NotificationGroupModel){

  }
}

export class AddMany implements Action{
  readonly type = NotificationActionTypes.ADD_NOTIFICATIONS;
  constructor(public notifications: Array<NotificationGroupModel>){

  }
}

export class UpsertOne implements Action {
  readonly type = NotificationActionTypes.UPSERT_NOTIFICATION;

  constructor(
    public notification: NotificationGroupModel) {}
}

export class UpsertMany implements Action {
  readonly type = NotificationActionTypes.UPSERT_NOTIFICATIONS;
  constructor(public notifications: Array<NotificationGroupModel> ) {}
}

export class UpdateOne implements Action{
  readonly type = NotificationActionTypes.UPDATE_NOTIFICATION;
  constructor(public notification: Update<NotificationGroupModel>){
    
  }
}

export class UpdateMany implements Action{
  readonly type = NotificationActionTypes.UPDATE_NOTIFICATIONS;
  constructor(public notifications: Array<Update<NotificationGroupModel>>){
    
  }
}

export class DeleteOne implements Action{
  readonly type = NotificationActionTypes.DELETE_NOTIFICATION;
  constructor(
    public id: string
  ){}
}

export class DeleteMany implements Action{
  readonly type = NotificationActionTypes.DELETE_NOTIFICATIONS;
  constructor(
    public ids: Array<string>
  ){}
}

export class DeleteAll implements Action{
  readonly type = NotificationActionTypes.DELETE_ALL_NOTIFICATIONS;
  constructor(public ids: Array<string>){}
}

export class DeleteState implements Action{
  readonly type = NotificationActionTypes.DELETE_ALL;
  constructor(
  ){}
}

export type NotificationActions = 
  AddOne 
  | AddMany 
  | UpsertOne 
  | UpsertMany 
  | DeleteOne 
  | DeleteMany 
  | DeleteAll
  | DeleteState
  | UpdateOne
  | UpdateMany
  | UpdateSelectedNotificationId;